import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { Int } from "../base/Int.js";
/**
 * @name i16
 * @description
 * A 16-bit signed integer
 */

export class i16 extends Int.with(16) {
  constructor() {
    super(...arguments);

    _defineProperty(this, "__IntType", 'i16');
  }

}